import { Player } from '@lottiefiles/react-lottie-player';
import clsx from 'clsx';
import React from 'react';

import { CellRendererProps } from '../../../DataTable.types';
import TopRightArrowIcon from '../../../../../../assets/Svg/TopRightArrowIcon';
import Tooltip from '../../../../Tooltip/Tooltip';

import styles from './CompanyNameCellRenderer.module.scss';
import { truncateByCharacters } from '../../../../../../utils/utils';

export interface handleRowClickProps {
    event?: React.MouseEvent | React.KeyboardEvent;
    row?: any;
    column?: any;
}

export const CompanyNameCellRenderer: React.FC<CellRendererProps> = ({ value, row, dynamicProps, column }) => {
    const { handleRowClick, isDisabled } = dynamicProps || {};

    // If disabled, render plain text without clickable styling
    if (isDisabled) {
        return (
            <div
                className={clsx(styles.CompanyNameContainer, styles.Disabled)}
                style={row?._isCollapsibleRow ? { marginLeft: '40px' } : {}}
            >
                <div className={styles.CompanyNameTextWrapper}>
                    <Tooltip content={value || ''} direction="top" usePortal fitContent>
                        <div className={styles.CompanyNameText}>
                            {value ? (row?._isCollapsibleRow ? truncateByCharacters(value, 15) : value) : '-'}
                        </div>
                    </Tooltip>
                </div>
            </div>
        );
    }

    return (
        <div
            className={clsx(styles.CompanyNameContainer, styles.IsPortfolio)}
            onClick={(e) => handleRowClick?.({ event: e, row, column })}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault(); // Prevent default action for Enter/Space
                    e.stopPropagation(); // Stop the event from bubbling up
                    // Call the row click handler with the assesseeOrgId
                    handleRowClick?.({ event: e, row, column });
                }
            }}
            role="button"
            tabIndex={0}
            style={row?._isCollapsibleRow ? { marginLeft: '40px' } : {}}
        >
            <div className={styles.CompanyNameTextWrapper}>
                <Tooltip content={value || ''} direction="top" usePortal fitContent>
                    <div className={styles.CompanyNameText}>
                        {value ? (row?._isCollapsibleRow ? truncateByCharacters(value, 15) : value) : '-'}
                    </div>
                </Tooltip>
                <div className={styles.CompanyNameIcon}>
                    <TopRightArrowIcon width={14} height={14} style={{ color: '#000000' }} />
                </div>
            </div>
        </div>
    );
};
